import { Chip, ChipLabel } from 'design-react-kit/dist/design-react-kit';
import { defineMessages, injectIntl } from 'react-intl';

import PropTypes from 'prop-types';
import { flattenToAppURL } from '@plone/volto/helpers';

const messages = defineMessages({
  other_arguments: {
    id: 'other_arguments',
    defaultMessage: 'Altri argomenti',
  },
});

/**
 * Arguments view component class.
 * @function Arguments
 * @params {object} location: object.
 * @returns {string} Markup of the component.
 */
const Arguments = ({ content, intl }) =>
  content?.tassonomia_argomenti?.length > 0 ? (
    <div className="other-arguments">
      <h5>
        <small>{intl.formatMessage(messages.other_arguments)}:</small>
      </h5>
      {content.tassonomia_argomenti.map(item => (
        <a
          href={flattenToAppURL(item['@id'])}
          key={item['@id']}
          title={item.title}
          className="text-decoration-none mr-2"
        >
          <Chip disabled={false} large={false} simple tag="div">
            <ChipLabel tag="span">{item.title}</ChipLabel>
          </Chip>
        </a>
      ))}
    </div>
  ) : null;

export default injectIntl(Arguments);

Arguments.propTypes = {
  content: PropTypes.shape({
    '@id': PropTypes.string,
    '@type': PropTypes.string,
    title: PropTypes.string,
    correlato_in_evidenza: PropTypes.object,
  }),
};
